import { Button, Typography, Box, Icon} from '@mui/material';
import {ChevronLeft} from '@mui/icons-material';
import {useTheme} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const MenuItem = ({ icon, title, internalLink, url }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    return (
        <Button
            variant="contained"
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                padding: "14px 0",
                borderRadius: "0",
                width: '100%',
                borderBottom: `1px solid ${theme.palette.background.gray}`,
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.default
            }}
            onClick={() => {
                internalLink ? navigate(internalLink) : 
                    window.open(url, '_blank', 'noopener,noreferrer');
                }
            }
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '10%',
                }}
            >
                <Icon
                    sx={{
                        display: 'flex',
                        fontSize: 24,
                        color: theme.palette.background.gray,
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    {icon}
                </Icon>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    width: '70%',
                }}
            >
                <Typography variant='caption2'>
                    {title}
                </Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '10%',
                }}
            >
                <ChevronLeft
                    sx={{
                        color: theme.palette.background.gray,
                    }}
                />
            </Box>
        </Button>
    );
};

export default MenuItem;
